export const SHOPING_CARD_KEY:string = 'shopingCard'
export const SHOPING_CHECK_KEY:string = 'shopingCheck'

export const EVENT_ADD_GOODS_CARD:string = 'eventAddCard'